import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import cn from 'classnames';
import { v4 as uuid } from 'uuid';
import { findIndex, find, groupBy, reject } from 'lodash-es';
import { safeInvoke } from '../../../library';
import { toasterClasses } from '../index';
import { ToastStack } from './toast-stack';
import { Toast } from './toast';
import { ToastProvider } from './toast-provider';
import { Portal } from '../../portal';
import { AnimatePresence } from 'framer-motion';
export var toaster = new ToastProvider();
export var ToasterContainer = function (_React$Component) {
  _inherits(ToasterContainer, _React$Component);
  var _super = _createSuper(ToasterContainer);
  function ToasterContainer() {
    var _this;
    _classCallCheck(this, ToasterContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "id", uuid());
    _defineProperty(_assertThisInitialized(_this), "state", {
      toasts: []
    });
    _defineProperty(_assertThisInitialized(_this), "show", function (options, id) {
      var toast = _this._createToastOptions(options, id);
      var delay = 0;
      if (!!id) {
        _this.setState(function (prevState) {
          var updatedToasts = reject(prevState.toasts, ['id', id]);
          if (updatedToasts.length < prevState.toasts.length) {
            delay = 350;
          }
          return {
            toasts: updatedToasts
          };
        });
      }
      setTimeout(function () {
        _this.setState(function (prevState) {
          return {
            toasts: [toast].concat(_toConsumableArray(prevState.toasts))
          };
        });
      }, delay);
      return toast.id;
    });
    _defineProperty(_assertThisInitialized(_this), "update", function (id, options) {
      _this.setState(function (prevState) {
        var index = findIndex(prevState.toasts, ['id', id]);
        if (index < 0) return null;
        prevState.toasts[index] = _objectSpread(_objectSpread({}, prevState.toasts[index]), options);
        return {
          toasts: prevState.toasts
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "dismiss", function (id) {
      var timeoutExpired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      _this.setState(function (_ref) {
        var toasts = _ref.toasts;
        return {
          toasts: toasts.filter(function (t) {
            var matchesKey = t.id === id;
            if (matchesKey) {
              safeInvoke(t.onDismiss, timeoutExpired);
            }
            return !matchesKey;
          })
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "clear", function () {
      _this.state.toasts.map(function (t) {
        return safeInvoke(t.onDismiss, false);
      });
      _this.setState(function (prevState) {
        return {
          toasts: []
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_getDismissHandler", function (toast) {
      return function (timeoutExpired) {
        _this.dismiss(toast.id, timeoutExpired);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "_renderToast", function (toast) {
      return React.createElement(Toast, _extends({}, toast, {
        key: toast.id,
        onDismiss: _this._getDismissHandler(toast)
      }));
    });
    return _this;
  }
  _createClass(ToasterContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      toaster.on('SHOW', this.show).on('UPDATE', this.update).on('DISMISS', this.dismiss).on('CLEAR', this.clear).connect(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      toaster.off('SHOW', this.show).off('CLEAR', this.clear).off('DISMISS', this.dismiss).off('CLEAR', this.clear).disconnect(this);
    }
  }, {
    key: "getToasts",
    value: function getToasts() {
      return this.state.toasts;
    }
  }, {
    key: "isToastActive",
    value: function isToastActive(id) {
      return !!find(this.state.toasts, ['id', id]);
    }
  }, {
    key: "_createToastOptions",
    value: function _createToastOptions(options) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "toast-".concat(uuid());
      var defaultProps = {
        position: 'top-right'
      };
      return _objectSpread(_objectSpread(_objectSpread({}, defaultProps), options), {}, {
        id: id
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var toasts = this.state.toasts;
      var groupedToasts = groupBy(toasts, 'position');
      var stacks = Object.keys(groupedToasts).map(function (position) {
        var groupToasts = groupedToasts[position];
        return React.createElement(ToastStack, {
          key: position,
          position: position
        }, !!groupToasts ? groupToasts.map(_this2._renderToast) : null);
      });
      return React.createElement(Portal, {
        className: cn(toasterClasses.CONTAINER, this.props.className)
      }, React.createElement(AnimatePresence, null, stacks));
    }
  }]);
  return ToasterContainer;
}(React.Component);
_defineProperty(ToasterContainer, "displayName", 'ToasterContainer');
_defineProperty(ToasterContainer, "defaultProps", {
  usePortal: true
});